import { atom } from 'jotai';
import { Message, MessageTypes } from '../../home/v1/typings/message-types';
import { ForwardMsgAction, ForwardMsgReducerAction, defaultForwardAtomState } from '../types';

export type ForwardMsgType = (MessageTypes & { statsId: string }) | undefined;

const forwardMsgAtom = atom<{
  showMsgsSelectView: false;
  showMsgsForwardPopup: false;
  showAboveMediaViewer: false;
  forwardMsg: ForwardMsgType[];
}>({
  forwardMsg: [],
  showMsgsSelectView: false,
  showMsgsForwardPopup: false,
  showAboveMediaViewer: false,
});

export const forwardMsgReducer = (prev: defaultForwardAtomState, action: ForwardMsgReducerAction): any => {
  const { type } = action;

  if (type == ForwardMsgAction.ADD_MSG_TO_FORWARD) {
    return {
      ...prev,
      forwardMsg: [...prev.forwardMsg, { ...action.data.msg, statsId: action.data.msgId }],
    };
  }
  if (type == ForwardMsgAction.RMV_MSG_TO_FORWARD) {
    const newState = [...(prev.forwardMsg ?? []).filter((item) => item?.statsId !== action.data.msgId)];
    return {
      ...prev,
      forwardMsg: newState,
    };
  }
  if (type == ForwardMsgAction.RESET_FORWARD_MSG_STATE) {
    return {
      ...prev,
      forwardMsg: [],
      showMsgsSelectView: false,
      showMsgsForwardPopup: false,
      showAboveMediaViewer: false,
    };
  }
  if (type == ForwardMsgAction.SHOW_MSGS_FORWARD_POPUP) {
    return {
      ...prev,
      showMsgsForwardPopup: true,
      showAboveMediaViewer: !!action.data?.fromMediaViewer,
    };
  }

  if (type == ForwardMsgAction.HIDE_MSGS_FORWARD_POPUP) {
    return {
      ...prev,
      showMsgsForwardPopup: false,
      showAboveMediaViewer: false,
    };
  }

  if (type == ForwardMsgAction.SHOW_MSGS_SELECT_VIEW) {
    return {
      ...prev,
      showMsgsSelectView: true,
      forwardMsg: [{ ...action.data.msg, statsId: action.data.msgId }],
    };
  }

  if (type == ForwardMsgAction.HIDE_MSGS_SELECT_VIEW) {
    return {
      ...prev,
      showMsgsSelectView: false,
      forwardMsg: [],
      showAboveMediaViewer: false,
    };
  }

  if (type == ForwardMsgAction.EMPTY_MSG_TO_FORWARD) {
    return {
      ...prev,
      forwardMsg: [],
    };
  }

  return prev;
};

export default forwardMsgAtom;
